import { createErrorHandbook, type ErrorsHandbook, ErrorsHandbookBuilder } from '@/6_shared/api'

export const searchErrorsHandbook: ErrorsHandbook = createErrorHandbook({
  ...new ErrorsHandbookBuilder(500).build()
})
